// Georgian translations
export const ka: Record<string, string> = {
  'menu.dashboard': 'დაფა',
  'menu.customers': 'კლიენტები',
  'menu.products': 'პროდუქტები',
  'menu.users': 'მომხმარებლები',
  'menu.settings': 'პარამეტრები',
  'menu.logout': 'გასვლა',
  'dashboard.title': 'დაფა',
  'dashboard.newOrder': 'ახალი შეკვეთა',
  'order.title': 'ახალი შეკვეთა',
  'order.customer': 'კლიენტი',
  'order.products': 'პროდუქტები',
  'order.total': 'ჯამი',
  'users.title': 'მომხმარებლები',
  'users.name': 'სახელი',
  'users.email': 'ელფოსტა',
  'common.yes': 'დიახ',
  'common.no': 'არა',
  'common.cancel': 'გაუქმება',
  'common.save': 'შენახვა',
  'common.search': 'ძებნა',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'შესვლა',
  'login.welcome': 'მოგესალმებით, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'ელფოსტა',
  'signup.phone': 'ტელეფონი',
  'menu.reportsAndAccounting': 'ანგარიშები და ბუღალტერია',
  'menu.systemAndCommunication': 'სისტემა და კომუნიკაცია',
};